/**
 * Console Control - Production Log Suppression
 *
 * Disables console methods in production to prevent information leakage
 * and reduce client-side noise. Keeps logs enabled in staging/development.
 *
 * @see .env.example - EXPO_PUBLIC_ENABLE_CONSOLE_LOGS
 */

// Web-only - no-op on native platforms
if (typeof window !== 'undefined') {
  const isConsoleEnabled = process.env.EXPO_PUBLIC_ENABLE_CONSOLE_LOGS === 'true';

  if (!isConsoleEnabled) {
    // Store original methods for potential debugging
    const noop = () => {};

    // Disable verbose console methods in production
    console.log = noop;
    console.debug = noop;
    console.info = noop;

    // Keep error and warn for critical issues (can be reviewed in Sentry)
    // console.error and console.warn remain active
  }
}
